import { createContext } from 'react';
import type { Session } from '@supabase/supabase-js';

interface AuthContextType {
  session: Session | null;
  isAdmin: boolean;
  authLoading: boolean;
  signOut: () => Promise<void>;
}

const initialState: AuthContextType = {
  session: null,
  isAdmin: false,
  authLoading: true,
  signOut: async () => {},
};

export const AuthContext = createContext<AuthContextType>(initialState);
